import React from 'react';

interface CloneIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const CloneIcon: React.FC<CloneIconProps> = ({
  width = 16,
  height = 16,
  className
}) => {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex'
      }}
      className={className}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width as number}
        height={height as number}
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_13294_32516)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.99978 3.55534H11.5553V1.33312C11.5553 1.21524 11.5085 1.1022 11.4252 1.01885C11.3418 0.935497 11.2288 0.888672 11.1109 0.888672H1.33312C1.21524 0.888672 1.1022 0.935497 1.01885 1.01885C0.935497 1.1022 0.888672 1.21524 0.888672 1.33312V11.1109C0.888672 11.2288 0.935497 11.3418 1.01885 11.4252C1.1022 11.5085 1.21524 11.5553 1.33312 11.5553H3.55534V3.99978C3.55534 3.88191 3.60216 3.76886 3.68551 3.68551C3.76886 3.60216 3.88191 3.55534 3.99978 3.55534Z"
            fill="#222222"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6675 4.44434H4.88976C4.77188 4.44434 4.65884 4.49116 4.57549 4.57451C4.49214 4.65786 4.44531 4.77091 4.44531 4.88878V14.6666C4.44531 14.7844 4.49214 14.8975 4.57549 14.9808C4.65884 15.0642 4.77188 15.111 4.88976 15.111H14.6675C14.7854 15.111 14.8985 15.0642 14.9818 14.9808C15.0652 14.8975 15.112 14.7844 15.112 14.6666V4.88878C15.112 4.77091 15.0652 4.65786 14.9818 4.57451C14.8985 4.49116 14.7854 4.44434 14.6675 4.44434ZM12.8898 10.4443H10.4453V12.8888H9.11198V10.4443H6.66753V9.111H9.11198V6.66656H10.4453V9.111H12.8898V10.4443Z"
            fill="#222222"
          />
        </g>
        <defs>
          <clipPath id="clip0_13294_32516">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default CloneIcon;
